export default "__VITE_ASSET__BzgxoPPr__"